/**
 * Request Account - Check Email Page
 *
 * Confirmation page after email verification is sent.
 */

import { Link } from '@tanstack/react-router'
import { Text } from '@/common/components/text'
import * as styles from './index.css'

export const Route = createFileRoute({
  component: CheckEmailPage,
})

function CheckEmailPage() {
  return (
    <div className={styles.container}>
      <div className={styles.card}>
        <div className={styles.header}>
          <img
            src="/images/orchard-offers.svg"
            alt="Orchard Cash Offer"
            className={styles.logo}
          />
          <Text as="h1" variant="h4" weight="bold" className={styles.title}>
            Check Your Inbox
          </Text>
          <Text variant="body" className={styles.subtitle}>
            We've sent you an email with a verification link.
            Click the link to continue your account request.
          </Text>
        </div>

        <div className={styles.infoBox}>
          <Text variant="bodySm" className={styles.infoText}>
            The link will expire in 24 hours. If you don't see the email,
            check your spam folder.
          </Text>
        </div>

        <div className={styles.linksContainer}>
          <Link to="/request-account" className={styles.primaryLink}>
            Didn't receive an email? Try again
          </Link>
        </div>
      </div>
    </div>
  )
}
